import { render, staticRenderFns } from "./ResidentGroupDetailModal.vue?vue&type=template&id=59266314&lang=pug"
import script from "./ResidentGroupDetailModal.vue?vue&type=script&lang=ts"
export * from "./ResidentGroupDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports